import StoreContainer from "./StoreContainer";

export default class PageHitStore {
  recordHit(): any {
    this.recordHitCount();
    this.recordPageUrl();
  }

  getCount(): number {
    return StoreContainer.LocalStorageStore.get("hitCount") || 0;
  }

  getPreviousPages(): string[] {
    const viewedUrls = this.getViewedUrls();
    viewedUrls.pop();
    return viewedUrls;
  }

  private recordPageUrl(): any {
    const urls = this.getViewedUrls();
    const fullUrl = window.parent.window.location.toString();
    const truncatedUrl = fullUrl.substr(0, 150);

    urls.push(truncatedUrl);

    if (urls.length > 10) {
      urls.shift();
    }

    StoreContainer.LocalStorageStore.set("viewedPages", urls);
  }

  private getViewedUrls(): string[] {
    return StoreContainer.LocalStorageStore.get("viewedPages") || [];
  }

  private recordHitCount(): any {
    const count = this.getCount();
    StoreContainer.LocalStorageStore.set("hitCount", count + 1);
  }
}
